import PropTypes from "prop-types";
import { FormattedMessage, FormattedPlural } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const StopoverFlightDurationLabel = ({ stopOverDayCount, className }) => {
	return (
		<Typography
			variant={TYPOGRAPHY_VARIANTS.SMALL}
			{...{ className }}
			isBold
			data-testid="stopover-flight-duration-label"
		>
			<FormattedPlural
				value={stopOverDayCount}
				one={
					<FormattedMessage
						values={{
							days: (
								<FormattedMessage
									values={{ duration: stopOverDayCount }}
									id="general.duration.days.singular"
								/>
							),
						}}
						id="stop.over.flight.duration.label"
					/>
				}
				other={
					<FormattedMessage
						values={{
							days: (
								<FormattedMessage
									values={{ duration: stopOverDayCount }}
									id="general.duration.days.plural"
								/>
							),
						}}
						id="stop.over.flight.duration.label"
					/>
				}
			/>
		</Typography>
	);
};

StopoverFlightDurationLabel.propTypes = {
	className: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	stopOverDayCount: PropTypes.number.isRequired,
};

export default StopoverFlightDurationLabel;
